import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const CartBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: ${props => props.primary ? 'linear-gradient(135deg, var(--accent), var(--accent-neon))' : 'var(--glass-2)'};
  color: ${props => props.primary ? '#fff' : 'var(--text-primary)'};
  border: 1px solid ${props => props.primary ? 'transparent' : 'var(--glass-border)'};
  padding: ${props => props.size === 'large' ? '16px 32px' : '10px 20px'};
  font-size: ${props => props.size === 'large' ? '16px' : '14px'};
  font-weight: bold;
  border-radius: ${props => props.size === 'large' ? '12px' : '8px'};
  cursor: pointer;
  box-shadow: ${props => props.primary ? '0 4px 15px var(--accent-glow)' : 'none'};
  transition: all 0.2s;

  &:hover {
    transform: scale(1.03);
    box-shadow: ${props => props.primary ? '0 8px 25px var(--accent-glow-strong)' : '0 4px 15px rgba(0,0,0,0.2)'};
    border-color: ${props => props.primary ? 'transparent' : 'var(--glass-border-hover)'};
  }

  svg {
    width: ${props => props.size === 'large' ? '20px' : '16px'};
    height: ${props => props.size === 'large' ? '20px' : '16px'};
  }
`;

const AddToCartWidget = ({ node }) => {
  const text = node.content?.text || 'In den Warenkorb';
  const showIcon = node.content?.showIcon !== false;
  const isPrimary = node.style?.desktop?.primary !== false;
  const size = node.style?.desktop?.size || 'normal';
  const align = node.style?.desktop?.align || 'center';

  return (
    <div style={{ textAlign: align, width: '100%' }}>
      <CartBtn primary={isPrimary} size={size} className="tef-bubbles">
        {showIcon && (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
        )}
        {text}
      </CartBtn>
    </div>
  );
};

registry.register('add_to_cart', {
  label: 'Add to Cart / Kaufen',
  icon: '🛒',
  category: 'ecommerce',
  defaultContent: {
    text: 'In den Warenkorb legen',
    showIcon: true
  },
  defaultStyle: {
    desktop: { primary: true, size: 'large', align: 'center' }
  },
  render: AddToCartWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Button',
          fields: [
            { name: 'content.text', label: 'Beschriftung', type: 'text' },
            { name: 'content.showIcon', label: 'Wagen Icon zeigen', type: 'select', options: [{label:'Ja', value:true}, {label:'Nein', value:false}] }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Design',
          fields: [
            { name: 'style.desktop.primary', label: 'Stil', type: 'select', options: [{label:'Primär (Auffällig)', value:true}, {label:'Sekundär (Glas)', value:false}] },
            { name: 'style.desktop.size', label: 'Größe', type: 'select', options: [{label:'Normal', value:'normal'}, {label:'Groß', value:'large'}] },
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label:'Links', value:'left'}, {label:'Zentriert', value:'center'}, {label:'Rechts', value:'right'}] }
          ]
        }
      ]
    }
  ]
});
